import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function LocalFuncionarioGridFilter() {
    const [filterCdLocalFuncionario, setFilterCdLocalFuncionario] = useState<FilterValuesProps>({
        property: 'cdLocalFuncionario',
        operator: 'eq',
        value: null,
    });
    const [filterDsLocalFuncionario, setFilterDsLocalFuncionario] = useState<FilterValuesProps>({
        property: 'dsLocalFuncionario',
        operator: 'like',
        value: null,
    });

    const [filterFgAtivo, setFilterFgAtivo] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        idProperty: 'vlStatus',
        operator: 'eq',
        value: true,
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterCdLocalFuncionario, setter: setFilterCdLocalFuncionario },
                { value: filterDsLocalFuncionario, setter: setFilterDsLocalFuncionario },
                { value: filterFgAtivo, setter: setFilterFgAtivo },
            ]}
        >
            <Grid size={{ lg: 3 }}>
                <CissTextField
                    label="Código"
                    value={filterCdLocalFuncionario.value}
                    onChange={(e) => setFilterCdLocalFuncionario((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 6 }}>
                <CissTextField
                    label="Local de entrega"
                    value={filterDsLocalFuncionario.value}
                    onChange={(e) => setFilterDsLocalFuncionario((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <StatusField
                    value={filterFgAtivo.value}
                    onChange={(e, value) => setFilterFgAtivo((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
        </Filter>
    );
}
